var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6998 0.900024C2.20275 0.900024 1.7998 1.30297 1.7998 1.80002V7.20002C1.7998 7.69708 2.20275 8.10002 2.6998 8.10002H6.2998C6.79686 8.10002 7.1998 7.69708 7.1998 7.20002V3.33642C7.1998 3.09773 7.10498 2.86881 6.9362 2.70002L5.3998 1.16363C5.23102 0.994846 5.0021 0.900024 4.76341 0.900024H2.6998ZM4.9498 3.60002C4.9498 3.3515 4.74833 3.15002 4.4998 3.15002C4.25128 3.15002 4.0498 3.3515 4.0498 3.60002V4.50002H3.1498C2.90128 4.50002 2.6998 4.7015 2.6998 4.95002C2.6998 5.19855 2.90128 5.40002 3.1498 5.40002H4.0498V6.30002C4.0498 6.54855 4.25128 6.75002 4.4998 6.75002C4.74833 6.75002 4.9498 6.54855 4.9498 6.30002L4.9498 5.40002H5.8498C6.09833 5.40002 6.2998 5.19855 6.2998 4.95002C6.2998 4.7015 6.09833 4.50002 5.8498 4.50002H4.9498V3.60002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAdd);
export default __webpack_public_path__ + "static/media/document-add.241cf0ed704533e9d6266f620617f0ef.svg";
export { ForwardRef as ReactComponent };